module.exports = __webpack_public_path__ + "static/media/ImpactStartupActiveUpdated.82a6a5f8.svg";